import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { REFRESH_LAST_UPDATED_INTERVAL } from '../constants';

export default (ViewComponent) => {
    class RefreshControlsHOC extends Component {
        constructor(props) {
            super(props);
            this.state = {
                intervalHandler: setInterval(() => {
                    this.forceUpdate();
                }, REFRESH_LAST_UPDATED_INTERVAL)
            };
        }

        componentWillUnmount() {
            clearInterval(this.state.intervalHandler);
        }

        render() {
            const { timeLastUpdated } = this.props;
            return <ViewComponent onClick={ this.props.onClick } timeLastUpdated={ timeLastUpdated } />;
        }
    }

    RefreshControlsHOC.propTypes = {
        onClick: PropTypes.func.isRequired,
        timeLastUpdated: PropTypes.number
    };

    RefreshControlsHOC.defaultProps = {
        timeLastUpdated: null
    };
    return RefreshControlsHOC;
};
